const initialState = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : [];

const nameReducer = (state = initialState, action) => {
    let { type, payload } = action;
    switch (type) {
        case "UPDATE_NAME":
            localStorage.setItem("userInfo", JSON.stringify(payload));
            return payload;
        default:
            return state;
    }
};

export default nameReducer;
